<script>
  // A job that finished cleanly. The only card with five actions.
  import { createEventDispatcher } from "svelte";
  import JobCard from "../UI/JobCard.svelte";
  import IconButton from "../UI/IconButton.svelte";
  import { download, deleteJob } from "../../lib/jobs.js";
  import { formatDateTime } from "../../lib/format.js";

  export let fileId;
  export let filename;
  export let uploadedDateTime;
  export let solvedDateTime;

  const dispatch = createEventDispatcher();

  async function remove() {
    if (await deleteJob(fileId, filename)) dispatch("changed");
  }

  $: meta = [
    { label: "Uploaded", value: formatDateTime(uploadedDateTime) },
    { label: "Solved", value: formatDateTime(solvedDateTime) },
  ];
</script>

<JobCard id={fileId} title={filename} status="solved" {meta}>
  <svelte:fragment slot="actions">
    <IconButton
      tip="Download input python file"
      icon="fa-code"
      colour="warning"
      onClick={() => download.python(fileId)}
    />
    <IconButton
      tip="Download input excel file"
      icon="fa-file-excel"
      colour="success"
      onClick={() => download.inputExcel(fileId)}
    />
    <IconButton
      tip="Download output excel file"
      icon="fa-file-excel"
      colour="primary"
      onClick={() => download.outputExcel(fileId)}
    />
    <IconButton
      tip="Download output log file"
      icon="fa-file-download"
      colour="info"
      onClick={() => download.log(fileId)}
    />
    <IconButton
      tip="Delete file"
      icon="fa-trash"
      colour="error"
      onClick={remove}
    />
  </svelte:fragment>
</JobCard>
